module.exports = __webpack_public_path__ + "static/img/cabecera.5977a7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/linea-etica/cabecera.jpg
// module id = avom
// module chunks = 0